/*
  Room View
  Markierte Betten
  Login

  Find Guest
  -> neue res -> auch in Betten einsetzen
  -> neue res -> betten in change
  -> Main guest change -> Betten id_gast mit gleicher Nr update

  Tabs
  - Reservation
  - Gruppe
  - History
    - Resdatum, user
  - Resfeldwert  

*/

import React, { useState, useEffect } from 'react';
import { Card, CardContent, Stack, 
  Button, TextField, Select, MenuItem, FormControl
 } from '@mui/material';
import { colorStyle, colorStyleHex, Legende, getCellcolor, getPrefix} from './farbschema'
import ViewDialog from './view'
import Sideblock  from './sideblock.js'
import EditGroup  from './edit_group.js'
import dataProvider from '../../lib/dataProvider';
import { useStore } from 'react-admin';

import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardDoubleArrowLeftIcon from '@mui/icons-material/KeyboardDoubleArrowLeft';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import KeyboardDoubleArrowRightIcon from '@mui/icons-material/KeyboardDoubleArrowRight';
import PreviewIcon from '@mui/icons-material/Preview';
import EventAvailableIcon from '@mui/icons-material/EventAvailable';

import moment from 'moment';
import 'moment/dist/locale/de';

const AppDash = ({permissions}) => {
  const [rowList, setRowList] = useState([]);
  const [gridData, setGridData] = useState({});
  const [mark1, setMark1] = useState({});
  const [specialday, setSpecialday] = useState([]);
  const [showOpen, setShowOpen] = useState(false);
  const [hostelsetting, setHostelsetting] = useState({});
  const [sideInfo, setSideInfo] = useState({});
  const [view, setView] = useState(false);
  const [farbschema, setFarbschema] = useState('ge');
  const [agenten, setAgenten] = useState([]);
  const [alterskats, setAlterskats] = useState([]);
  const [bookingchannels, setBookingchannels] = useState([]);
  const [calGroups, setCalGroups] = useState([]);
  const [calDates, setCalDates] = useState([]);
  const [showView, setShowView] = useState(false);
  const [localSettings, setLocalSettings] = useStore('localSettings', {});
  const [viewSettings, setViewSettings] = useState({"AnzahlNaechte": 7,
            "AnzBetten": 20,
            "ColorSet": 0,
            "ShowKat": "",
            "StartOffset": 0,
            "ShowBedInfo": false,
            "ShowInfos": true,
            "ShowMatratzen": false,
            "UseRoomColor": true,
            "VisibDays": 3,
            "Viewname": "",
            "Zimmerlist": false});
  const [gastdetails, setGastdetails] = useState([]);
  
  useEffect(() => {
    if (view===false) return;
    dataProvider.getList('appRow', {
        filter: { ShowKat: viewSettings.ShowKat, Zimmerlist: viewSettings.Zimmerlist, ShowMatratzen: viewSettings.ShowMatratzen  },
        sort: false,
        pagination: { page: 1, perPage: 999 },
    })
      .then(response => {
        if (response.data) {
          setRowList(response.data);
        }
      });
    dataProvider.update('calCalendar', {id:0, data: { } })
      .then(response => {
        if (response.data) {
          setCalGroups(response.data);
        }
      });
    const start = moment().add(viewSettings.StartOffset-2, 'days').format('YYYYMMDD');
    dataProvider.update('calCalendar/getdates', {id:0, data: { start: start, days: viewSettings.AnzahlNaechte } })
      .then(response => {
        if (response.data) {
          setCalDates(response.data);
        }
      });
  }, [view, viewSettings]);

  useEffect(() => {
    dataProvider.getList('appHostelsetting', { sort: false,pagination: { page: 1, perPage: 200 } })
      .then(response => {
        const hs = {};
        response.data.forEach((r)=>{
          hs[r.id] = r.value;
        })
        setHostelsetting(hs);
        if (view===false) {
          setView('view1');
          let vs = hs['view1'];
          if (!vs.AnzahlNaechte) vs = {AnzahlNaechte: 8};
          setViewSettings(vs);
        }
      });
    dataProvider.getList('setAgentcontract', { sort: false, pagination: { page: 1, perPage: 200 } })
      .then(response => { setAgenten(response.data) } )
    dataProvider.getList('setAgecategory', { sort: false, pagination: { page: 1, perPage: 200 } })
      .then(response => { setAlterskats(response.data) } )
    dataProvider.getList('setBookingchannel', { sort: false, pagination: { page: 1, perPage: 200 } })
      .then(response => { setBookingchannels(response.data) } )
    dataProvider.update('appSideinfo', {id:0, data: { } })
      .then(response => { setSideInfo(response.data) } )
    dataProvider.getList('setGuestdetail', { filter:{addbase:true}, sort: false, pagination: { page: 1, perPage: 200 } })
      .then(response => { 
        const gd = [];
        response.data.forEach((r)=>{
          const g = { id: r.id, titel: r.titel_en?r.titel_en:r.titel_de, fields:[] };
          for (let i = 1; i<=6; i++) {
            g.fields.push(r['bez'+i+'_en']?r['bez'+i+'_en']:r['bez'+i+'_de']);
          }
          gd.push(g);
        })
        setGastdetails(gd);
       })
    window.document.addEventListener('keyup', doc_key, false);
    window.document.addEventListener('keydown', doc_key, false);
    window.document.addEventListener('keypress', doc_key, false);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (view===false) return;
    const start = moment().add(viewSettings.StartOffset-2, 'days').format('YYYYMMDD');
    dataProvider.getList('appGrid', {
        filter: { start, duration: viewSettings.AnzahlNaechte+1 },
        sort: false,
        pagination: { page: 1, perPage: 20 },
    })
      .then(response => {
        if (response.data) {
          response.data.forEach((r)=>{
            setGridData((gd)=>{ return {...gd, [r.bett_id]:r.bel}});
          })
        }
      });
      dataProvider.getList('setSpecialday', { sort: false, pagination: { page: 1, perPage: 200 }, filter:{start, dauer: viewSettings.AnzahlNaechte} })
      .then(response => { setSpecialday(response.data) } )
  }, [view, viewSettings]);

  const updateViewSettings = (f, v) => {
    setViewSettings((vs)=> ({...vs, [f]:v}));
  }

  const closeEdit = () => {
/*    
    setResInfo({tgast:{}});
    setResChange({gaeste:{}});
*/    
    setMark1({});
    setShowOpen(false);
  }
        
  const doc_key = (ev) => {
    const keyCode = ev.code;
    if (!keyCode) return;
    if (keyCode.match(/^F[0-9]{1,2}$/)) {
      ev.preventDefault();
      ev.stopPropagation();
      if (ev.type==='keyup') {
        const v = 'view'+keyCode.slice(1);
        if (hostelsetting[v]) {
          setView(v);
          const vs = hostelsetting[v];
          if (!vs.AnzahlNaechte) vs.AnzahlNaechte = 8;
          setViewSettings(vs);
        }
      }
    }
  }

  const openRes = (id) => {
    setShowOpen({id});
  }

  const cellClick = (ev) => {
    const id = ev.target.id.split('_');
    if (id[2]) {
      openRes(id[2]);
    }
  }

  const viewChange = (ev) => {
    setView(ev.target.value);
    setViewSettings(hostelsetting[ev.target.value]);
  }

  const nav = (offset) => (ev) => {
    if (offset===0) {
      updateViewSettings('StartOffset', 0);  
    }
    else {
      setViewSettings((vs)=>({...vs, StartOffset: vs.StartOffset+offset}));
    }
  }

  const dateChange = (ev) => {
    const diff = moment(ev.target.value).diff(moment(), 'days');
    updateViewSettings('StartOffset', diff);  
  }

  const start = moment().add(viewSettings.StartOffset-1, 'days');

//  if (rowList.length < 1) return null;
  if (!viewSettings?.AnzahlNaechte) return null;
  let lastMonth = -1;
  let lastZimmerId = 0;
  const heute = parseInt(moment().format('YYYYMMDD'));
  const bgcolors = {};
  for (var i=0; i<viewSettings.AnzahlNaechte; i++) {
    var mom = moment().add(i+viewSettings.StartOffset-1, 'days');
    var date = parseInt(mom.format('YYYYMMDD'));
    if (date===heute) {
      bgcolors[date] = 'rgba(0,0,255, 0.1)';
    }
    else {
      const d = mom.day();
      if (d===6 || d===0) {
        bgcolors[date] = 'rgba(0,0,0, 0.05)';
      }
    }
  }

  const DateGroup = ({group, label}) => {
    if (!Object.keys(calDates).length || !Object.keys(calGroups).length) return (<tr><td></td></tr>);
    const idname = 'id_' + group + '_gr';
    var spancnt2 = 1;
    const res = [];
    for (var i=0; i<=viewSettings.AnzahlNaechte; i++) {
      var tag = moment(start).add(i, 'days').format('YYYYMMDD');
      var tag2 = moment(start).add(i+1, 'days').format('YYYYMMDD');
      const dateinfo = calDates[tag];
      if (!dateinfo) continue;
      const dateinfo2 = calDates[tag2];
      if ( !dateinfo2 || dateinfo[idname]!==dateinfo2[idname]) {
        var spn = spancnt2;
        spancnt2 = 1;
        const gruppe = calGroups[group][dateinfo[idname]];
        res.push(
              <th colSpan={spn} align="center" key={tag} style={gruppe?.farbe && colorStyleHex(gruppe.farbe.substr(1))}>
                <div>{gruppe?.bezeichnung}</div>
              </th>
        )
      }
      else {
        spancnt2++;
      }
    }
    return (<tr><th style={{width:viewSettings.ShowBedInfo?'130px':'50px'}}>{label}</th>{res}</tr>);
  }

  const tdClick = (clickBett, clickDatum) => (ev) => {
    if (mark1?.bett_id===clickBett && mark1?.datum===clickDatum) {
      setMark1({});
    }
    else {
      if (!mark1?.bett_id) {
        setMark1({bett_id:clickBett, datum:clickDatum});
        return;
      }
      // Neue Reservation anlegen
      const duration = moment(clickDatum).diff(moment(mark1.datum), 'days') + 1;
      let bereich = 0;
      const betten=[];
      rowList.forEach((bett, k) => {
        if (bereich===2) return false;
        if (bett.bett_id===mark1.bett_id) { 
          bereich = 1;
        }
        if (bereich===0) return null;

        if (bett.bett_id===clickBett) {
          bereich = 2;
        }
        betten.push(bett.bett_id);
      });
      dataProvider.getList('appBettinfo', { filter: { sel: betten, start: mark1.datum, duration }, sort: false, pagination: { page: 1, perPage: 999 }, })
      .then(response => {
        if (response.data) {
          console.log(response.data);
          const betten = response.data.filter(b=>b.belegt===0);
          betten.map(b=>b.alteskat_id=alterskats[0].id);
          const info = { 
            id:-1, resnr:0, ankunft: mark1.datum, abreise: moment(clickDatum).add(1, 'days').format('YYYYMMDD'), dauer: duration,
            betten: betten,
            gaeste: {},
            gastlist: [],
            id_agent: 0,
            id_buchungskanal: 9,
            id_gast: -1,
            netto: 0,
            res_nr: -1,
            services: [],
            status: 0,
            zahlung:[],
          };
          setShowOpen({id: -1, info});
        }
      });
    }
  }
  const fkeylist = [];
  for (let i=1; i<=18; i++) {
    const key = 'view' + i;
    if (hostelsetting[key]) {
      const viewname = hostelsetting[key].Viewname;
      if (viewname) {
        const keyname = i<=12?'[F'+i+'] ':'';
        fkeylist.push({key, keyname, viewname});
      }
    }
  }

/*  
  const infoBetten = getInfoBetten();
  console.log(['info', getInfo('ankunft'), infoBetten])
  const editInfo = {
    ankunft: getInfo('ankunft'),
    abreise: getInfo('abreise'),
  }
*/    
  return (  
    <div id="appDash">
    <Stack direction="row">
      <Card >
        <CardContent sx={{paddingTop:0}}>
          <toolbar style={{display:'flex', alignItems:'center'}}>
            <Button onClick={nav(-viewSettings.AnzahlNaechte)}><KeyboardDoubleArrowLeftIcon /></Button>
            <Button onClick={nav(-1)}><KeyboardArrowLeftIcon /></Button>
            <Button onClick={nav(0)}><EventAvailableIcon /></Button>
            <TextField id="date" type="date" value={start.format('YYYY-MM-DD')} onChange={dateChange} sx={{m:'0 0 4px 0', width:'9em', '& .MuiInputBase-input': { p: '4px' } }} size="small" />
            <Button onClick={nav(1)}><KeyboardArrowRightIcon /></Button>
            <Button onClick={nav(viewSettings.AnzahlNaechte)}><KeyboardDoubleArrowRightIcon /></Button>
            <Button onClick={()=>setShowView(true)}><PreviewIcon /></Button>

    {view !== false &&
            <FormControl sx={{m:'0 0 4px 0', '& .MuiSelect-select': { p: '4px' } }}>
              <Select label="View" value={view} onChange={viewChange} >
      {fkeylist.map((el) => (
                <MenuItem key={el.key} value={el.key}>{el.keyname}{el.viewname}</MenuItem>
      ))}     
              </Select>
            </FormControl>
    }
            <FormControl  sx={{m:'0 0 4px 0', '& .MuiSelect-select': { p: '4px' } }}>
              <Select value={farbschema} onChange={(ev)=>setFarbschema(ev.target.value)}>
                <MenuItem value="ge">Gender</MenuItem>
                <MenuItem value="ar">Arrival</MenuItem>
                <MenuItem value="bc">Booking channel</MenuItem>
                <MenuItem value="ag">Agent</MenuItem>
                <MenuItem value="de">Departure</MenuItem>
              </Select>
            </FormControl>
          </toolbar>
          <table className="appgrid">
            <thead>
            {localSettings.ogOnline!==false && <DateGroup group="online" label="Online" /> }
            {localSettings.ogPrices!==false && <DateGroup group="preis"  label="Prices" /> }
            {localSettings.ogServices!==false && <DateGroup group="zusatz" label="Services" /> }
              <tr className="dateline">
                <th className={viewSettings.ShowBedInfo?'ShowBedInfo':''}>{start.format('YYYY')}</th>
      {[...Array(viewSettings.AnzahlNaechte)].map((el, k) => {
        var date = moment(start).add(k, 'days');
        var first = date.format('M')!==lastMonth;
        lastMonth = date.format('M');
        let bgcol = (date.day()%6)===0?'#eee':'#FFF';
        const sd = specialday?.find((el)=>el.datum===date.format('YYYY-MM-DD'));
        if (sd) {
          bgcol = (date.day()%6)===0?'#8f8':'#cFc';
        }
        return (
                  <th key={k} style={{fontSize:"0.8125rem", backgroundColor:bgcol}} title={sd?.bemerkung?sd?.bemerkung:''}>
                    {first?date.format('MMM'):''}<br/>
                    <span>{date.format('ddd D')}</span>
                  </th>
        )}            
      )}            
                </tr>
              </thead>
            <tbody>
      {rowList.map((bett, k) => {
  //      if (bett.bett != '06A') return null;
        const topline = bett.id_zimmer !== lastZimmerId?'#666':'#eee';
        lastZimmerId = bett.id_zimmer; 
        const bel = gridData[bett.bett_id]?gridData[bett.bett_id]:[];
        return (
          <tr key={k}>
            <td style={{...colorStyle(bett.matratze?'cccccc':(viewSettings.UseRoomColor?bett.farbe:bett.pkfarbe)), borderTop:topline==='#666'?'2px solid '+topline:'0px'}}>{bett.bezeichnung} {bett.buchstabe} {viewSettings.ShowBedInfo?bett.bemerkung:''}</td>
            {[...Array(viewSettings.AnzahlNaechte)].map((x, k) => {
              const dGestern = moment(start).add(k-1, 'days').format('YYYYMMDD');
              const d = moment(start).add(k, 'days').format('YYYYMMDD');

              let bardiv = null;
              const tdStyle = { borderTop:'2px solid '+topline };
              let id = bett.bett_id + '_' + d;
              if (bel[dGestern]) {
                const cell = bel[dGestern];
                const id = bett.bett_id + '_' + d + '_' + cell.reservation_id;
                const cStyle = colorStyleHex(getCellcolor(farbschema, cell, heute, agenten, bookingchannels));
                const style = {...cStyle, width:((cell.dispDauer-0.1)*100)+'%', left: '-60%'};
                if (k===0) {
                  style.left = '-5px';
                  style.width = ((cell.dispDauer-0.7)*100)+'%';
                  style.borderRadius = '0px 5px 5px 0px';
                }
                if (cell.extright) {
                  style.width = "200%";
                }
                let bartext = (<>&nbsp;</>);
                if (viewSettings.ShowInfos) {
                  bartext = (<>{cell.name} {cell.vorname} {cell.res_nr}</>);
                }
//                bartext = (<>BW {bartext}</>);
                if (k===0) {
                }
                bardiv = (<div id={id} className="bar" style={style} /*draggable="true" onDrop={dropHandler} onDragOver={dragoverHandler}*/
                  onClick={cellClick} >{getPrefix(cell)}{bartext}</div>);
              }
/*              
              if (editInfo.ankunft< d && d <= editInfo.abreise && infoBetten.find((el)=>el.bett_id===bett.bett_id)) {
                bardiv = (<div id="edit" className="bar" style={{backgroundColor:'rgba(0,255,0,0.5)', left: '-60%', width:'90%'}}>edit</div>);
              }
*/                
              tdStyle.backgroundColor = bett.matratze?'rgba(0,0,0,0.2)':(bgcolors[parseInt(d)]?bgcolors[d]:null);
              if (mark1?.bett_id===bett.bett_id && mark1?.datum===d) {
                tdStyle.backgroundColor = 'rgba(0,0,255,0.5)';
              }
              return (
                <td key={id} style={tdStyle} onClick={bardiv?null:tdClick(bett.bett_id, d)}>
                  {bardiv}
                </td>
              )
            })}
          </tr>
        )
      })}
            </tbody>
          </table>
        </CardContent>
      </Card>
      <Card style={{minWidth:'250px'}}>
  {localSettings.arrivals!==false &&
        <Sideblock title="Arrivals" list={sideInfo?.arrivals} openRes={openRes} />
  }
  {localSettings.departures!==false &&
        <Sideblock title="Departures" list={sideInfo?.departures} openRes={openRes} />
  }
  {localSettings.reminders!==false &&
        <Sideblock title="Reminders" list={sideInfo?.reminders} openRes={openRes} />
  }
  {localSettings.legend!==false &&
    <>
    {(localSettings.arrivals!==false || localSettings.departures!==false || localSettings.reminders!==false) &&
        <hr />
    }
        <CardContent sx={{paddingTop:0}}>
          <Legende farbschema={farbschema} agenten={agenten} bookingchannels={bookingchannels}/>
        </CardContent>
    </>
  }
        </Card>
    </Stack>
    <ViewDialog open={showView} setOpen={setShowView} viewSettings={viewSettings} setViewSettings={setViewSettings} 
      hostelsetting={hostelsetting} setHostelsetting={setHostelsetting} localSettings={localSettings} setLocalSettings={setLocalSettings} />
    <EditGroup showOpen={showOpen} closeEdit={closeEdit} agenten={agenten} bookingchannels={bookingchannels} alterskats={alterskats}
      gastdetails={gastdetails} rowList={rowList} gridData={gridData} 
    />
    </div>
  );
}
export default AppDash;
